import { render, staticRenderFns } from "./DepartmentsMenu.vue?vue&type=template&id=32c196df&scoped=true&"
import script from "./DepartmentsMenu.vue?vue&type=script&lang=js&"
export * from "./DepartmentsMenu.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsMenu.vue?vue&type=style&index=0&id=32c196df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c196df",
  null
  
)

export default component.exports